import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_etiquetas, FieldValue} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
  namespaced:true,
  state:{
    registro: [],
  },
  actions:{
    obtener_todos:({state})=>{
      state.cargando = true
      coleccion_etiquetas.onSnapshot(doc=>{
        if(doc.exists) state.registro = doc.data().lista
      })
    },

    agregar: ( context, contenido) => new Promise ( async (resolver, rechazar)=>{
      try{
        await coleccion_etiquetas.update({lista: FieldValue.arrayUnion(contenido)}) 
        resolver()
      } catch (e) {
        try {
          await coleccion_etiquetas.set({lista: FieldValue.arrayUnion(contenido)})
          resolver()
        } catch ( e ) {
          console.log(e)
          rechazar( e )
        }
      }
    }),

    eliminar: (context, contenido) => coleccion_etiquetas.update({lista: FieldValue.arrayRemove(contenido)}) 
    
    
  },
  getters:{
    registro: ({registro}) => registro,
  }
}
